
import { ElMessage } from "element-plus";
import { getEnum, login } from "@/api/index";
import type { ElForm } from "element-plus";

import { useStore } from "vuex";
type FormInstance = InstanceType<typeof ElForm>;

import { putParameter, updParametert } from "@/api/backstage";
import {
  defineComponent,
  reactive,
  computed,
  ref,
  unref,
  toRefs,
  watch,
  onMounted,
} from "vue";
export default defineComponent({
  name: "新增参数",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  emits: ["close"],
  setup(opt, contex) {
    const store = useStore();
    let isEdit = false;
    let show = opt.open;

    const dataMap: any = reactive({
      ruleFormRef: ref<FormInstance>(),
      ruleForm: {
        title: "",
        value: "",
        remark: "",
      },
      rules: {
        title: [{ required: true, message: "请输入参数名", trigger: "blur" }],
        value: [{ required: true, message: "请输入参数值", trigger: "blur" }],
      },

      async putParameter() {
        const res = await putParameter(dataMap.ruleForm);
        if (res.code === 200) {
          ElMessage({
            message: "操作成功",
            type: "success",
          });
          dataMap.ruleFormRef.resetFields();
          contex.emit("close", false);
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
        }
      },
      async updParametert() {
        const res = await updParametert(dataMap.ruleForm);
        if (res.code === 200) {
          ElMessage({
            message: "操作成功",
            type: "success",
          });
          dataMap.ruleFormRef.resetFields();
          contex.emit("close", false);
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
        }
      },
    });

    if (opt.row) {
      isEdit = true;
      dataMap.ruleForm = opt.row;
    }

    const close = () => {
      contex.emit("close", false);
    };

    // watch(
    //   () => opt,
    //   (newv, oldv) => {
    //     console.log(opt);

    //     if (opt.row) {
    //       dataMap.isEdit = true;
    //       dataMap.ruleForm = opt.row;
    //     } else {
    //       dataMap.isEdit = false;
    //     }
    //   }
    // );

    const submitForm = (formEl: FormInstance | undefined) => {
      if (!formEl) return;
      formEl.validate((valid) => {
        if (valid) {
          isEdit ? dataMap.updParametert() : dataMap.putParameter();
        } else {
          console.log("error submit!");
          return false;
        }
      });
    };

    return {
      show,
      store,
      isEdit,
      submitForm,
      close,
      ...toRefs(dataMap),
    };
  },
});
